import * as React from 'react';
import { RadioButton } from '@ixicare/ui';
import { Description, Group, Option, Reveal } from './choiceStyles';

export interface Choice {
  value: string;
  title: string;
  description?: string;
  // Rendered under the choice while it is the selected one.
  content?: React.ReactNode;
}

interface Props {
  // Radio group name. Must be unique on the page, including against a nested list.
  name: string;
  label: string;
  value: string;
  choices: Choice[];
  onChange: (value: string) => void;
}

// An exclusive list of options, each with an explanation and optionally something revealed when
// chosen. @ixicare/ui has no radio that carries a description or reveals content, so RadioButton
// supplies the input and title and the rest is built around it.
const ChoiceList: React.FC<Props> = ({ name, label, value, choices, onChange }) => (
  <Group role="radiogroup" aria-label={label}>
    {choices.map((choice) => (
      <Option key={choice.value}>
        <RadioButton
          id={`${name}-${choice.value}`}
          name={name}
          value={choice.value}
          checked={value === choice.value}
          onChange={() => onChange(choice.value)}
          label={choice.title}
        />
        {choice.description && <Description htmlFor={`${name}-${choice.value}`}>{choice.description}</Description>}
        {value === choice.value && choice.content && <Reveal>{choice.content}</Reveal>}
      </Option>
    ))}
  </Group>
);

export default ChoiceList;
